import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Box, Divider} from 'views/components';
import {RefreshWidget} from 'views/module';

import ClientLeadName from './client_lead_name/ClientLeadName';
import ClientLeadStatus from './client_lead_status/ClientLeadStatus';

const ClientLeadTitle = (props) => {
  const clientLeadData = props.clientLeadData;
  const clientLeadBackend = props.clientLeadBackend;
  const refresh = props.refresh;
  const setRefresh = props.setRefresh;

  return (
    <>
      <Stack
        direction='row'
        justifyContent={'space-between'}
        alignItems="center"
        sx={{
          p: 1,
          px: {md: 2, xs: 1},
        }}
      >
        <Box>
          <Stack
            direction='row'
            spacing={1}
          >
            <ClientLeadStatus
              clientLeadData={clientLeadData}
              clientLeadBackend={clientLeadBackend}
            />
            <ClientLeadName
              clientLeadData={clientLeadData}
              clientLeadBackend={clientLeadBackend}
            />
          </Stack>
        </Box>
        <Box sx={{minWidth: '37%'}}>
          <RefreshWidget numRefresh={refresh} setNumRefresh={setRefresh} justifyContent='end'/>
        </Box>
      </Stack>
      <Divider/>
    </>
  );
};
ClientLeadTitle.propTypes = {
  clientLeadRn: PropTypes.string.isRequired,
  clientLeadData: PropTypes.object.isRequired,
  clientLeadBackend: PropTypes.object.isRequired,
  refresh: PropTypes.number.isRequired,
  setRefresh: PropTypes.func.isRequired,
};

export default React.memo(ClientLeadTitle);
